<template>
  <section>
    <div class="row" v-if="Object.keys(efiles).length > 0">
      <div class="col">
        <div v-for="(items, group) in efiles" :key="group">
          <h5 v-if="Object.keys(efiles).length > 1" class="mt-3">{{ group }}</h5>
          <b-table
            responsive
            hover
            small
            :items="items"
            :fields="fields"
            head-variant="light"
          >
            <!-- 格式欄位 -->
            <template #cell(format)="data">
              {{ data.item.name.split('.').pop().toUpperCase() }}
            </template>

            <!-- 名稱欄位 -->
            <template #cell(name)="data">
              <a :href="data.item.url" target="_blank" download>{{ data.item.name }}</a>
            </template>

            <!-- 大小欄位 -->
            <template #cell(size)="data">
              {{ data.item.formatted_size }}
            </template>

            <!-- 日期欄位 -->
            <template #cell(date)="data">
              {{ isUpdated(data.item) ? $t('book.efile-list.label.updated-date') : $t('book.efile-list.label.upload-date') }}
              {{ (isUpdated(data.item) ? data.item.updated_at : data.item.created_at).slice(0, 10) }}
            </template>

            <!-- 頁數欄位 -->
            <template #cell(pages)="data">
              {{ data.item.attached && data.item.attached.pages_count ? data.item.attached.pages_count : '-' }}
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col">
        <span>{{ $t('book.efile-list.message.no-efile') }}</span>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'

import { TablePlugin } from 'bootstrap-vue'
import i18n from '@/plugins/i18n.js'

Vue.use(TablePlugin)

export default {
  i18n,
  name: 'book-efile-list',
  props: {
    efiles: {
      type: Object,
      required: true
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'format',
          label: this.$t('book.efile-list.table.header.format'),
          thStyle: { width: '10%' }
        },
        {
          key: 'name',
          label: this.$t('book.efile-list.table.header.name')
        },
        {
          key: 'size',
          label: this.$t('book.efile-list.table.header.size'),
          thStyle: { width: '15%' }
        },
        {
          key: 'date',
          label: this.$t('book.efile-list.table.header.date'),
          thStyle: { width: '25%' }
        },
        {
          key: 'pages',
          label: this.$t('book.efile-list.table.header.pages'),
          thStyle: { width: '10%' }
        }
      ]
    }
  },
  methods: {
    isUpdated(item) {
      if (!item.created_at || !item.updated_at) return false;
      return item.created_at.slice(0, 10) !== item.updated_at.slice(0, 10);
    }
  },
  created() {
    // 
  },
  components: {
    // 
  }  
}
</script>